
export default {
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    icons() {
      return [
        {
          image:
            "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/clipboardIcon.svg",
          text: this.copied ? "Copied" : "Copy Link",
          onClick: async () => {
            await navigator.clipboard.writeText(window.location.href);
            this.copied = true;
            setTimeout(() => {
              this.$emit("hideMenu");
            }, 500);
          },
        },
        {
          image:
            "https://s3-ap-southeast-2.amazonaws.com/snooze-bedbuilder-interface/build/static/images/emailIcon.svg",
          text: "Email",
          onClick: () => {
            const subject = encodeURIComponent(
              "Your personalised bed design is ready"
            );
            const body = encodeURIComponent(
              `Take a closer look at the bed selected to suit your style, comfort and space.\n\n ${window.location.href}`
            );
            window.location.href = `mailto:?subject=${subject}&body=${body}`;
            this.$emit("hideMenu");
          },
        },
      ];
    },
  },
};
